import axios from 'axios';
import { mapResponse } from './transform';

export default {
  async getPlate(context) {
    try {
      const { data } = await axios.get(`${process.env.API_BASE_URL}/products/vehicle/plate`);
      const response = data.data;
      context.commit('updateVehiclePlate', mapResponse({ type: 'vehicleInfo', response }));
    } catch (error) {
      return error;
    }
  },
  async getVehicle(context, { query, type }) {
    try {
      const { data } = await axios.get(`${process.env.API_BASE_URL}/products/vehicle/vehicle?${query}`);
      const response = data.data;
      const resultMap = mapResponse({ type: 'vehicleInfo', response });
      if (type === 'vehicleBrand') {
        context.commit('updateVehicleBrand', resultMap);
      } else if (type === 'vehicleModel') {
        context.commit('updateVehicleModel', resultMap);
      } else if (type === 'vehicleSeries') {
        context.commit('updateVehicleSeries', resultMap);
      }
    } catch (error) {
      return error;
    }
  },
  async getVehiclePriceRange(context, dataSend) {
    try {
      const { data } = await axios.post(`${process.env.API_BASE_URL}/products/vehicle/price-range`, dataSend);
      const response = data.data;
      return mapResponse({ type: 'vehiclePriceRange', response });
    } catch (error) {
      // const resultMap = mapResponse({ type: 'vehiclePriceRange' });
      return error;
    }
  },
  async getListSearchResult(context, { payload }) {
    try {
      let link = `${process.env.API_BASE_URL}/products/vehicle`;
      const { data } = await axios.post(link, payload);
      const response = data.data;
      // context.commit('updateListSearchResults', mapResponse({ type: 'productList', response }));
      return mapResponse({ type: 'productList', response });
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async getDocumentsType(context) {
    try {
      let link = `${process.env.API_BASE_URL}/policies/documents/types`;
      const { data } = await axios.get(link);
      const response = data.data;
      context.commit('updateDocumentsType', mapResponse({ type: 'documentsType', response }));
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async getDocumentPresignLink(context, payload) {
    try {
      const { data } = await this.$axios.post(`${process.env.API_BASE_URL}/policies/documents/get-upload-url`, payload);
      const response = data;
      return mapResponse({ type: 'documentPresignLink', response });
    } catch (error) {
      return false;
    }
  }
};
